
import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message, Tag, Icon, Select } from 'antd';
import { withTranslation } from 'react-i18next';
import { getAdminList, putDisableAdmin, putEnableAdmin, getRoleList, postCreateAdmin, delAdmin, putAdmin } from '../../../axios';
import { convertUTCDateToLocalDate } from '../../../utils'
import '../index.less'



const FormItem = Form.Item;

const AdminManage = (props) => {
	const t = props.t;
	const [data, setData] = useState([]);
	const [modalVisible, setModalVisible] = useState(false);
	const [editing, setEditing] = useState(null);
	const [formValues, setFormValues] = useState({});
	const [formErrors, setFormErrors] = useState({});
	// Role selection related state (for Select dropdown)
	const [roleTableData, setRoleTableData] = useState([]);
	const [roleTableLoading, setRoleTableLoading] = useState(false);
	const [roleTablePage, setRoleTablePage] = useState(1);
	const [roleTablePageSize] = useState(5);
	const [roleTableTotal, setRoleTableTotal] = useState(0);
	const [roleTableSelected, setRoleTableSelected] = useState([]);
	const [roleTableSelectedDetails, setRoleTableSelectedDetails] = useState([]);
	const [roleTableSearch, setRoleTableSearch] = useState('');
	const [roleDropdownOpen, setRoleDropdownOpen] = useState(false);

	// Role selection change
	const handleRoleTableSelect = (selectedRowKeys, selectedRows) => {
		setRoleTableSelected(selectedRowKeys);
		setFormValues(prev => ({ ...prev, roles: selectedRowKeys }));
	// Merge selected details
		setRoleTableSelectedDetails(prev => {
			// Newly selected details
			const newDetails = selectedRows.filter(row => !prev.some(r => r.id === row.id));
			// Selected details not displayed on this page
			const remainDetails = prev.filter(r => selectedRowKeys.includes(r.id));
			// Only keep all currently selected details
			return [...remainDetails, ...newDetails];
		});
	};

	useEffect(() => {
		fetchRoleTableData();
	}, [roleTablePage, roleTableSearch]);

	const fetchRoleTableData = async () => {
		setRoleTableLoading(true);
		const params = { page: roleTablePage, per_page: roleTablePageSize, keyword: roleTableSearch };
		const res = await getRoleList(params);
		setRoleTableLoading(false);
		if (res.code === 100000 && res.data && res.data.list) {
			setRoleTableData(res.data.list);
			setRoleTableTotal(res.data.pagination.total);
		}
	};

	// Role table pagination
	const handleRoleTablePageChange = (page) => {
		setRoleTablePage(page);
	};

	// Role table search
	// const handleRoleTableSearch = (e) => {
	// 	setRoleTableSearch(e.target.value);
	// 	fetchRoleTableData(1, e.target.value);
	// };

	// Select dropdown expand/collapse
	const handleRoleDropdownVisibleChange = (open) => {
		setRoleDropdownOpen(open);
		if (open) fetchRoleTableData(1, roleTableSearch);
	};
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(5);
	const [searchEmail, setSearchEmail] = useState('');
	const [total, setTotal] = useState(0);

	useEffect(() => {
		fetchAdminList();
	}, [page, searchEmail]);

	const fetchAdminList = async () => {
		setLoading(true);
		const params = { page, per_page: pageSize, keyword: searchEmail };
		const res = await getAdminList(params);
		setLoading(false);
		if (res.code === 100000 && res.data && res.data.list) {
			setData(res.data.list);
			setTotal(res.data.pagination.total);
		}
	};

	const EnableAdmin = async (id) => {
		const res = await putEnableAdmin(id);
		if (res.code === 100000) {
			message.success(t('EnableSuccess'));
			fetchAdminList();
		} else {
			message.error(res.data.message || t('EnableFailed'));
		}
	};

	const DisableAdmin = async (id) => {
		const res = await putDisableAdmin(id);
		if (res.code === 100000) {
			message.success(t('DisableSuccess'));
			fetchAdminList();
		} else {
			message.error(res.data.message || t('DisableFailed'));
		}
	};

	const DeleteAdmin = async (record) => {
		const res = await delAdmin(record.id);
		if (res.code === 100000) {
			message.success(t('DeleteSuccess'));
			fetchAdminList();
		} else {
			message.error(res.data.message || t('DeleteFailed'));
		}
	}

	const handleSearchEmailChange = (e) => {
		setSearchEmail(e.target.value);
		setPage(1);
	};

	const showModal = (record = null) => {
		setModalVisible(true);
		setEditing(record);
		setFormValues(record ? { ...record } : {});
		if (record && record.roles) {
			setRoleTableSelected(record.roles.map(r => r.id));
			setRoleTableSelectedDetails(record.roles);
		} else {
			setRoleTableSelected([]);
			setRoleTableSelectedDetails([]);
		}
	};

	const handleCancel = () => {
		setModalVisible(false);
		setEditing(null);
		setFormValues({});
		setFormErrors({});
		setRoleTableSelected([]);
		setRoleTableSelectedDetails([]);
		setRoleTableSearch('');
	};

	const handleDelete = record => {
		if (record.is_disabled === 1) {
			EnableAdmin(record.id);
		} else {
			DisableAdmin(record.id);
		}
	};

	const handleFormChange = (e) => {
		const { name, value } = e.target;
		setFormValues(prev => ({ ...prev, [name]: value }));
	};

	const handleOk = () => {
		let errors = {};
		if (!formValues.email) {
			errors.email = t('PleaseEnterEmail');
		} else if (!/^\S+@\S+\.\S+$/.test(formValues.email)) {
			errors.email = t('EmailFormatError');
		}
		if (!formValues.roles || formValues.roles.length === 0) {
			errors.roles = t('PleaseSelectRole');
		}
		setFormErrors(errors);
		if (Object.keys(errors).length > 0) return;
		console.log('Form Values:', formValues);
		if (editing) {
			handleUpdateAdmin({ id: editing.id, email: formValues.email, role_ids: formValues.roles });
		} else {
			handleCreateAdmin({ email: formValues.email, role_ids: formValues.roles });
		}
		setModalVisible(false);
		setEditing(null);
		setFormValues({});
		setFormErrors({});
		setRoleTableSelected([]);
		setRoleTableSelectedDetails([]);
		setRoleTableSearch('');
	};

	const handleCreateAdmin = async (values) => {
		const res = await postCreateAdmin(values);
		if (res.code === 100000) {
			message.success(t('CreateSuccess'));
			fetchAdminList();
		} else {
			message.error(res.data.msg || t('CreateFailed'));
		}
	};

	const handleUpdateAdmin = async (values) => {
		const res = await putAdmin(values);
		if (res.code === 100000) {
			message.success(t('UpdateSuccess'));
			fetchAdminList();
		} else {
			message.error(res.data.msg || t('UpdateFailed'));
		}
	}

	const pageChange = (page, pageSize) => {
		setPage(page);
		setPageSize(pageSize);
	};

	const columns = [
		{ title: t('Email'), dataIndex: 'email', key: 'email' },
		{
			title: t('Roles'),
			key: 'roles',
			render: (text, record) =>
				<ul className='last-login-ip'>
					{record.roles && record.roles.map(role => <li key={role.id}>{role['role_name']}</li>)}
				</ul>
		},
		{
			title: t('CreateTime'),
			dataIndex: 'create_time',
			key: 'create_time',
			render: (text) => convertUTCDateToLocalDate(text)
		},
		{
			title: t('LastLoginTime'),
			dataIndex: 'last_login_time',
			key: 'last_login_time',
			render: (text) => convertUTCDateToLocalDate(text)
		},
		{
			title: t('LastLoginIP'),
			key: 'last_login_ip',
			render: (text, record) =>
				<ul className='last-login-ip'>
					<li>{t('LastLoginIP')}: {record.last_login_ip || '-'}</li>
					<li>{t('LastLoginIPArea')}: {record.last_login_ip_area || '-'}</li>
					<li>{t('LastLoginIPAreaCode')}: {record.last_login_ip_area_code || '-'}</li>
				</ul>
		},
		{
			title: t('Status'),
			key: 'status',
			render: (text, record) =>
				<span>{record.is_disabled ? <Tag color="red">{t('Disabled')}</Tag> : <Tag color="green">{t('Enabled')}</Tag>}</span>
		},
		{
			title: t('Action'),
			key: 'action',
			render: (text, record) => (
				<span className='action-btns'>
					<Button type="link" onClick={() => { showModal(record) }} >{t('Edit')}</Button>
					<Button type="link" onClick={() => { handleDelete(record) }}>{record.is_disabled === 1 ? t('Enabled') : t('Disabled')}</Button>
					{record.is_disabled === 1 && (
						<Button type="link" onClick={() => { DeleteAdmin(record) }}>{t('Delete')}</Button>
					)}
				</span>
			),
		},
	];

	return (
		<div className='main-new'>
			<div className="main-cotent">
				<div className='permissionManagement'>
					<div className='topBox'>
						<Input
							style={{ width: '300px' }}
							className='inputEllipsis'
							placeholder={t('SearchEmail')}
							prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
							onPressEnter={handleSearchEmailChange}
							onChange={handleSearchEmailChange}
							allowClear
						/>
						<Button type="primary" onClick={() => showModal()}>{t('AddAdmin')}</Button>
					</div>
					<Table
						rowKey={record => record.id}
						columns={columns}
						dataSource={data}
						loading={loading}
						pagination={{ current: page, pageSize: pageSize, total: total, onChange: pageChange }}
						locale={{
							emptyText:
								<div className='empty-table'>
									<p> {t('NoData')}</p>
								</div>
						}} />
					<Modal
						title={editing ? 'Edit' : 'Add'}
						visible={modalVisible}
						onOk={handleOk}
						onCancel={handleCancel}
						className='newModal'
					>
						<Form layout="vertical">
							<FormItem
								label={t('Email')}
								required
								validateStatus={formErrors.email ? 'error' : ''}
								help={formErrors.email}
							>
								<Input disabled={editing} name="email" value={formValues.email || ''} onChange={handleFormChange} placeholder={t('PleaseEnterEmail')} />
							</FormItem>
							<FormItem
								label={t('RoleSelection')}
								required
								validateStatus={formErrors.roles ? 'error' : ''}
								help={formErrors.roles}
							>
								<Select
									mode="multiple"
									open={roleDropdownOpen}
									value={roleTableSelected}
									onDropdownVisibleChange={handleRoleDropdownVisibleChange}
									dropdownRender={() => (
										<div style={{ padding: 8, width: '100%' }} onMouseDown={e => e.preventDefault()}>
											{/* <Input.Search
												placeholder={t('SearchFor', { user: t('Role') })}
												value={roleTableSearch}
												onChange={handleRoleTableSearch}
												style={{ marginBottom: 8 }}
												allowClear
												onMouseDown={e => e.preventDefault()}
												onFocus={e => e.preventDefault()}
											/> */}
											<Table
												rowKey="id"
												columns={[
													{ title: t('RolesName'), dataIndex: 'name', key: 'name' },
													{ title: t('RoleDescription'), dataIndex: 'description', key: 'description' }
												]}
												dataSource={roleTableData}
												loading={roleTableLoading}
												pagination={{ current: roleTablePage, pageSize: roleTablePageSize, total: roleTableTotal, onChange: handleRoleTablePageChange }}
												rowSelection={{
													selectedRowKeys: roleTableSelected,
													onChange: handleRoleTableSelect,
													type: 'checkbox',
												}}
												size="small"
												onMouseDown={e => e.stopPropagation()}
											/>
										</div>
									)}
									style={{ width: '100%' }}
									placeholder={t('PleaseSelectRole')}
									onChange={(selectedIds) => {
										const selectedRows = selectedIds.map(id => roleTableData.find(r => r.id === id)).filter(Boolean);
										handleRoleTableSelect(selectedIds, selectedRows);
									}}
									optionLabelProp="label"
								>
									{roleTableSelected.map(id => {
										const role = roleTableSelectedDetails.find(r => r.id === id) || { name: id };
										const label = role.role_name || role.name || id;
										return <Select.Option key={id} value={id} label={label}>{label}</Select.Option>;
									})}
								</Select>
							</FormItem>
						</Form>
					</Modal>
				</div>
			</div>
		</div>
	);
}

export default withTranslation(['common'])(AdminManage);
